import { get } from '@kit/utils/APIV1.js'

//https://localhost/cms-service/index.php/wp-json/v1/holiday-page?pretty
export const page = async() => {
  return get(`holiday-page`)
}

export const holidays = async() => {
  return get('holidays')
}